import { render, staticRenderFns } from "./DashboardOrderAttention.vue?vue&type=template&id=cfb25108&scoped=true&"
import script from "./DashboardOrderAttention.vue?vue&type=script&lang=js&"
export * from "./DashboardOrderAttention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfb25108",
  null
  
)

export default component.exports